import React, { useRef, useState } from "react";

import "react-international-phone/style.css";

import GenericTableView from "../../components/GenericTableView";
import { Dialog } from "primereact/dialog";
import { ConfirmDialog } from "primereact/confirmdialog";
import { GenericTableColumTypes, GenericTableFilterTypes } from "../../enum/TableView";
import { GenericTableColumns } from "../../models/GenericTableViewModel";
import { useNavigate } from "react-router-dom";
import { FilterMatchMode } from "primereact/api";
import SiteSetupEmployeeAdd from "./Site-Setup-Employee-Add";

export default function SiteSetup(modalProps: any) {
  const record = modalProps.record;

  const siteId = record?.id;

  const navigate = useNavigate();

  const [selectedRole, setSelectedRole] = useState({} as any);
  const [visible, setVisible] = useState(false);
  const [reload, setReload] = useState(false);
  const dialog = useRef(null as any);

  const baseFilter = {
    name: { value: "", matchMode: FilterMatchMode.CONTAINS },
    active: { value: true, matchMode: FilterMatchMode.CONTAINS },
    required: { value: null, matchMode: FilterMatchMode.CONTAINS },
  };

  const queryParams = {
    siteId: siteId,
  };

  const addButton = (row: any) => {
    console.log("addButton row == ", row);
    setSelectedRole(null);
    setVisible(true);
  };

  const itemSelected = (row: any) => {
    console.log("itemSelected row == ", row);
    setSelectedRole(row.value);
    // setVisible(true);
    viewSelected(row);
  };

  const contextItemSelected = (row: any) => {
    console.log("contextItemSelected row == ", row);
    setSelectedRole(row.value);
  };

  const viewSelected = (row: any) => {
    setVisible(true);
  };

  const contextItems = () => {
    let objArray = [];
    objArray.push({
      label: "View",
      icon: "pi pi-fw pi-eye",
      command: viewSelected,
    });
    return objArray;
  };

  const columns: GenericTableColumns[] = [
    {
      field: "name",
      header: "Name",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: false,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "legal_reference",
      header: "Legal Reference",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "type",
      header: "Type",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "type_name",
      header: "Item",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "appointment_assigned",
      header: "Appointment Assigned",
      type: GenericTableColumTypes.Boolean,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Boolean,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "employee_list",
      header: "Employee",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: false,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
  ];

  return (
    <React.Fragment>
      <GenericTableView
        reload={reload}
        baseFilters={baseFilter}
        queryParams={queryParams}
        url="site-setup"
        columns={columns}
        contextItems={contextItems}
        itemSelect={itemSelected}
        contextItemSelected={contextItemSelected}
      />

      <Dialog
        ref={dialog}
        header={"Assign Employees"}
        visible={visible}
        style={{ width: "50vw" }}
        onHide={() => setVisible(false)}
      >
        <SiteSetupEmployeeAdd
          setGlobalLoader={modalProps.setGlobalLoader}
          setReload={setReload}
          reload={reload}
          id={selectedRole?.id}
          record={selectedRole}
          setVisible={setVisible}
          toast={modalProps.toast}
          siteId={siteId}
        />
      </Dialog>

      <ConfirmDialog />
    </React.Fragment>
  );
}
